import React from 'react';
import ReactDOM from 'react-dom/client';
import { Routing } from './routes';
//! React Router Dom
import { BrowserRouter } from 'react-router-dom'
// React Redux
import {Provider} from 'react-redux'
import store from './redux/store'
// Actions
import { NhealthAction } from './_actions/action.api'
import { DecryptedOBJ } from './utils/Encryption';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <Routing />
      </Provider>
    </BrowserRouter>
  </React.StrictMode>
);